import { gql } from '@apollo/client';

export const fetchSubscriptionsForTransactionAccount = gql`
  query fetchSubscriptionsForTransactionAccount(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptions(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          transactionAccountNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          edition
          cloudSiteHostname
          billingGroupId
          provisioningStatus
          id
          billedUsers
          trial
          isSandbox
          isApp
          nextBillingTimestamp
          upgradeTrial {
            offeringName
            offeringId
          }
        }
      }
    }
  }
`;
